<template>
  <div>
    <div class="control">
      <div>
        <h3 class="show-control-text">É estabelecimento de pequeno porte?</h3>
        <label class="switch">
          <input type="checkbox" id="show_pequenoporte" v-model="showControl.pequenoporte" @change="onChangePequenoPorte" />
          <span class="slider"></span>
        </label>
      </div>
    </div>
    <div class="control">
      <div>
        <label class="show-control-text" for="show_aprovados">Exibir documentos aprovados</label>
        <label class="switch">
          <input type="checkbox" id="show_aprovados" v-model="showControl.aprovados" />
          <span class="slider"></span>
        </label>
      </div>
      <div>
        <label class="show-control-text" for="show_reprovados">Exibir documentos reprovados</label>
        <label class="switch">
          <input type="checkbox" id="show_reprovados" v-model="showControl.reprovados" />
          <span class="slider"></span>
        </label>
      </div>
      <div>
        <label class="show-control-text" for="show_pendentes">Exibir documentos Pendentes</label>
        <label class="switch">
          <input type="checkbox" id="show_pendentes" v-model="showControl.pendentes" />
          <span class="slider"></span>
        </label>
      </div>
    </div>
    <table class="table">
      <thead>
        <tr>
          <th>Código</th>
          <th>Tipo do Documento</th>
          <th>Arquivo</th>
          <th>Observações</th>
          <th>Data e hora do envio</th>
          <th>Status</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody
        is="transition-group"
        name="rowtrans"
        @enter="enter"
        @beforeEnter="beforeEnter"
        @leave="leave"
        :css="false"
      >
        <tr
          v-for="(document, index) in tableRows"
          class="ttrow"
          :key="document.table_id"
          :style="{display: isVisible(document) ? 'table-row' : 'none'}"
        >
          <!-- Divisor row: -->
          <td
            v-if="document.rowType === tableRowType.DIVISOR && !document.hide"
            colspan="7"
            class="td-divisor"
          >
            <div>{{ document.message }}</div>
          </td>
          <!-- Text row: -->
          <td v-if="document.rowType === tableRowType.TEXT && !document.hide"></td>
          <td
            v-if="document.rowType === tableRowType.TEXT && !document.hide"
            colspan="6"
            class="td-text"
          >
            <div class="row">
              <div class="col-md-3">
                <label>Motivo reprovação:</label>
              </div>
              <div class="col-md-9">
                <textarea
                  v-if="document.edit"
                  :name="'motivoReprova[' + document.id + ']'"
                  placeholder="Informe o motivo da reprovação"
                ></textarea>
                <p class="text text-red" v-if="!document.edit">{{ document.message }}</p>
              </div>
            </div>
          </td>
          <!-- Document rows: -->
          <td v-if="document.rowType === tableRowType.DOCUMENT">
            <div>{{ document.id || "-" }}</div>
          </td>
          <td v-if="document.rowType === tableRowType.DOCUMENT">
            <div>
              {{ document.typeName.split(" - Escala")[0] }}
              <span
                v-if="document.mandatory"
                class="text text-red"
              >(*)</span>
            </div>
          </td>
          <td v-if="document.rowType === tableRowType.DOCUMENT">
            <div>
              <input
                v-if="document.editMode"
                type="file"
                accept="application/pdf"
                required
                @change="onChangeInputFile(index, $event)"
                :name="
                  plants.includes(String(document.typeId))
                    ? `documentos[planta][${document.typeId}]${
                        document.id && !canMakeCopy
                          ? '[' + document.id + ']'
                          : ''
                      }[]`
                    : `documentos[anexo][${document.typeId}]${
                        document.id && !canMakeCopy
                          ? '[' + document.id + ']'
                          : ''
                      }`
                "
              />
              <a
                v-if="!document.editMode"
                :href="document.document_url"
                @click="document.seenFile = true"
                target="_blank"
              >Visualizar</a>
            </div>
          </td>
          <td v-if="document.rowType === tableRowType.DOCUMENT">
            <div>{{ document.obs ? document.obs : "-" }}</div>
          </td>
          <td v-if="document.rowType === tableRowType.DOCUMENT">
            <div>
              {{
              document.created_at
              ? document.created_at
              : "Aguardando submissão"
              }}
            </div>
          </td>
          <td v-if="document.rowType === tableRowType.DOCUMENT" class="text text-center">
            <div>
              <div v-if="document.status && document.id">
                <i
                  title="Aprovado"
                  v-if="document.status == 'APROVADO'"
                  class="fa fa-thumbs-o-up fa-2x text text-success"
                ></i>
                <i
                  title="Reprovado"
                  v-if="document.status == 'REPROVADO'"
                  class="fa fa-thumbs-o-down fa-2x text text-red"
                ></i>
                <i
                  title="Pendente"
                  v-if="document.status == 'PENDENTE'"
                  class="fa fa-exclamation-triangle fa-2x text text-warning"
                ></i>
              </div>
              <div v-if="!document.status">
                {{
                !document.file_uploaded ? "Arquivo vazio" : "Não submetido"
                }}
              </div>
            </div>
          </td>
          <td v-if="document.rowType === tableRowType.DOCUMENT" class="text text-center">
            <div>
              <a
                href="#"
                @click="insert_row(index, $event)"
                class="fa fa-plus-circle"
                v-if="
                  (plants.includes(String(document.typeId)) ||
                    multipleFiles.includes(String(document.typeId))) &&
                    !aprovador &&
                    (projectStatus == 9 || canMakeCopy)
                "
              ></a>
              <a
                href="#"
                @click="remove_row(index, $event)"
                class="fa fa-times-circle"
                v-if="
                  document.editMode &&
                    document.status === 'PENDENTE' &&
                    (plants.includes(String(document.typeId)) || multipleFiles.includes(String(document.typeId))) &&
                    tableRows.filter(el => el.typeId === document.typeId)
                      .length > 1
                "
              ></a>
              <!-- <a
                href="#"
                @click="edit_row(index, $event)"
                class="fa fa-edit"
                v-if="
                  ((canMakeCopy && document.status === 'APROVADO') ||
                    ((!aprovador && document.status === 'PENDENTE')) && !document.editMode)
                "
              ></a> -->
              <!-- Temporariamente removido, devido ao bug causado ao editar arquivos. RegistroEtapa2Controller.php:915, a função de MD5 causava um erro, pois é enviado um array com o ID do documento a ser editado, ao invés da string com o nome do arquivo. (27/10/2020) -->

              <div class="validate" v-if="aprovador && document.codStatus == 9">
                <button
                  class="evaluate-text"
                  v-if="!document.seenFile"
                  @click="onTryEvaluateWOSeeFile"
                >Avaliar o documento</button>
                <select
                  :name="'status_aprovador[' + document.id + ']'"
                  v-model="document.statusAvaliation"
                  @change="onChangeStatusAvaliacao(index, $event)"
                  v-if="document.seenFile"
                >
                  <option value="9">Pendente</option>
                  <option value="7">Aprovado</option>
                  <option value="8">Reprovado</option>
                </select>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <input type="hidden" name="documents_ignore" :value="getEditedIds" />
    <input type="hidden" name="documents_deleted" :value="JSON.stringify(deletedItems)" />
  </div>
</template>

<script>
export default {
  props: {
    projectStatus: {
      required: true
    },
    documentsType: {
      required: true
    },
    codDocumentsMandatory: {
      required: true
    },
    codDocumentsOptional: {
      required: false,
      default: () => []
    },
    value: {
      required: true
    },
    aprovador: {
      required: true
    },
    motivosReprovacao: {
      required: true
    },
    canMakeCopy: {
      required: true
    },
    isCloned: {
      required: false
    },
    isPequenoPorte: {
      required: false,
    },
    disabledPequenoPorte: {
      required: false,
    },
  },
  computed: {
    getEditedIds() {
      return this.tableRows.reduce((acc, tableRow) => {
        if (
          tableRow.id &&
          tableRow.rowType === this.tableRowType.DOCUMENT &&
          tableRow.editMode &&
          tableRow.file_uploaded
        ) {
          return acc + (acc != "" ? "," : "") + tableRow.id;
        }
        return acc;
      }, "");
    }
  },
  data() {
    return {
      plants: ["23", "35", "22", "21", "10"],
      multipleFiles: ["29"],
      tableRows: [],
      deletedItems: [],
      latest_id: 0,
      ptb: 0,
      mh: 0,
      tableRowType: {
        DOCUMENT: "DOCUMENT",
        TEXT: "TEXT",
        DIVISOR: "DIVISOR"
      },
      showControl: {
        aprovados: true,
        reprovados: true,
        pendentes: true,
        pequenoporte: false
      }
    };
  },
  beforeMount() {
    if(this.isPequenoPorte === true){
      this.showControl.pequenoporte = true;
    }
    this.generateItems();
  },
  mounted() {
    if(this.disabledPequenoPorte === true){
      let checkboxPequenoPorte = document.getElementById('show_pequenoporte');
      checkboxPequenoPorte.setAttribute('disabled', 'true');
    }
    let inputPequenoPorte = document.getElementById('input-pequeno-porte');
    inputPequenoPorte.value = this.showControl.pequenoporte;
  },
  methods: {
    isVisible(document) {
      if(document.typeId === 34 && this.showControl.pequenoporte){
        return true;
      }
      if (document.codStatus !== undefined && document.typeId !== 34) {
        if (document.codStatus === 9 && this.showControl.pendentes) {
          return true;
        } else if (document.codStatus === 7 && this.showControl.aprovados) {
          return true;
        } else if (document.codStatus === 8 && this.showControl.reprovados) {
          return true;
        }
      } else if (document.rowType === this.tableRowType.DIVISOR) {
        return true;
      }
      return false;
    },
    onChangePequenoPorte(){
      let inputPequenoPorte = document.getElementById('input-pequeno-porte');
      inputPequenoPorte.value = this.showControl.pequenoporte;
    },
    generateItems() {
      if (this.value && this.value.length > 0) {
        this.value.forEach(document => {
          let typeName = this.documentsType[document.tipo_documento];

          const documentData = {
            table_id: ++this.latest_id,
            id: document.cod_documentos,
            rowType: this.tableRowType.DOCUMENT,
            typeId: document.tipo_documento,
            created_at: moment(
              document.data_hora_upload,
              "YYYY-MM-DD HH:mm"
            ).format("DD/MM/YYYY HH:mm"),
            document_url: `/util/get-arquivo-pdf/name/${document.nome_arquivo}`,
            codStatus: document.status_anexo,
            status: document.status,
            statusAvaliation: document.status_anexo,
            typeName,
            editMode: false,
            seenFile: false,
            file_uploaded: false,
            obs: document.obs,
            mandatory: this.codDocumentsMandatory.includes(
              document.tipo_documento
            )
          };
          const accIndex = this.tableRows.length;
          this.tableRows.push(documentData);

          if (document.status === "REPROVADO") {
            // Motivo da reprovação
            this.tableRows.push({
              table_id: ++this.latest_id,
              id: document.cod_documentos,
              rowType: this.tableRowType.TEXT,
              message: this.motivosReprovacao[document.cod_documentos],
              typeId: document.tipo_documento,
              codStatus: 8,
              hide: false,
              edit: false
            });
          }

          if (
            !this.aprovador &&
            this.value.filter(
              el =>
                el.tipo_documento == documentData.typeId &&
                el.status !== "REPROVADO"
            ).length === 0 &&
            this.tableRows.filter(
              el => el.typeId == documentData.typeId && el.editMode
            ).length === 0
          ) {
            // Adiciona uma linha para fazer upload do documento reprovado
            this.tableRows.splice(accIndex, 0, {
              table_id: ++this.latest_id,
              id: null,
              rowType: this.tableRowType.DOCUMENT,
              document_url: null,
              typeId: documentData.typeId,
              typeName: documentData.typeName,
              file_uploaded: false,
              created_at: null,
              editMode: true,
              status: "PENDENTE",
              codStatus: 9
            });
          }
        });

        if (!this.aprovador && (this.projectStatus == 9) || this.canMakeCopy) {
          this.codDocumentsMandatory.forEach(codDocument => {
            const exists = this.tableRows.find(
              item => item.typeId == codDocument
            );
            if (!exists && ((this.projectStatus == 9 && !this.isCloned) || (this.canMakeCopy && this.plants.includes(String(codDocument))))) {
              const emptyDocument = {
                table_id: ++this.latest_id,
                id: null,
                rowType: this.tableRowType.DOCUMENT,
                document_url: null,
                typeId: codDocument,
                typeName: this.documentsType[codDocument],
                file_uploaded: false,
                created_at: null,
                editMode: true,
                status: "PENDENTE",
                codStatus: 9,
                mandatory: true
              };
              this.tableRows.push(emptyDocument);
            }
          });

          this.codDocumentsOptional.forEach(cod => {
            if (this.value.find(item => item.tipo_documento == cod)) {
              return;
            }
            const emptyDocument = {
              table_id: ++this.latest_id,
              id: null,
              rowType: this.tableRowType.DOCUMENT,
              document_url: null,
              typeId: cod,
              typeName: this.documentsType[cod],
              file_uploaded: false,
              created_at: null,
              editMode: true,
              status: "PENDENTE",
              codStatus: 9,
              mandatory: false
            };
            this.tableRows.push(emptyDocument);
          });
        }
        const exists = this.tableRows.find(
          item => item.typeId == 35
        );

        if(!exists){
          const emptyDocument = {
            table_id: ++this.latest_id,
            id: null,
            rowType: this.tableRowType.DOCUMENT,
            document_url: null,
            typeId: 35,
            typeName: this.documentsType[35],
            file_uploaded: false,
            created_at: null,
            editMode: true,
            status: "PENDENTE",
            codStatus: 9,
            mandatory: true
          };
          this.tableRows.push(emptyDocument);
        }
      } else {
        this.codDocumentsMandatory.forEach(cod => {
          const emptyDocument = {
            table_id: ++this.latest_id,
            id: null,
            rowType: this.tableRowType.DOCUMENT,
            document_url: null,
            typeId: cod,
            typeName: this.documentsType[cod],
            file_uploaded: false,
            created_at: null,
            editMode: true,
            status: "PENDENTE",
            codStatus: 9,
            mandatory: true
          };
          this.tableRows.push(emptyDocument);
        });

        this.codDocumentsOptional.forEach(cod => {
          const emptyDocument = {
            table_id: ++this.latest_id,
            id: null,
            rowType: this.tableRowType.DOCUMENT,
            document_url: null,
            typeId: cod,
            typeName: this.documentsType[cod],
            file_uploaded: false,
            created_at: null,
            editMode: true,
            status: "PENDENTE",
            codStatus: 9,
            mandatory: false
          };
          this.tableRows.push(emptyDocument);
        });
      }

      setTimeout(this.afterPopulateTable, 500);
    },
    onChangeInputFile(index, ev) {
      this.tableRows[index].file_uploaded = Boolean(ev.target.value);
    },
    insert_row(index, evt) {
      evt.preventDefault();
      evt.stopPropagation();
      const parentItem = this.tableRows[index];

      this.tableRows.splice(index + 1, 0, {
        table_id: ++this.latest_id,
        id: null,
        rowType: this.tableRowType.DOCUMENT,
        document_url: null,
        status: "PENDENTE",
        codStatus: 9,
        typeId: parentItem.typeId,
        typeName: parentItem.typeName,
        file_uploaded: false,
        created_at: null,
        editMode: true
      });
    },
    remove_row(index, evt) {
      evt.preventDefault();
      evt.stopPropagation();
      if (this.tableRows[index].id) {
        this.deletedItems.push(this.tableRows[index].id);
      }
      this.tableRows.splice(index, 1);
    },
    edit_row(index, evt) {
      evt.preventDefault();
      evt.stopPropagation();
      this.tableRows[index].editMode = true;
    },
    beforeEnter(el) {
      let divs = el.querySelectorAll("div");
      for (let i = 0; i < divs.length; i++) {
        divs[i].style.maxHeight = "0px";
        divs[i].style.paddingTop = "0px";
        divs[i].style.paddingBottom = "0px";
      }
    },
    enter(el, done) {
      let divs = el.querySelectorAll("div");
      Velocity(
        divs,
        { maxHeight: this.mh, paddingTop: this.ptb, paddingBottom: this.ptb },
        { duration: 300, complete: done }
      );
    },
    leave(el, done) {
      let divs = el.querySelectorAll("div");
      Velocity(
        divs,
        { maxHeight: "0px", paddingTop: "0px", paddingBottom: "0px" },
        { duration: 300, complete: done }
      );
    },
    afterPopulateTable() {
      let div = document.querySelector(".ttrow td div");
      if(div) {
        let style = window.getComputedStyle(div);
        this.ptb = style.getPropertyValue("padding-top");
        this.mh = style.getPropertyValue("max-height");
      }
    },
    onTryEvaluateWOSeeFile(ev) {
      ev.preventDefault();
      this.$toast.info("Você precisa visualizar o arquivo antes de avaliar!", {
        position: "top-right",
        timeout: 3000
      });
    },
    onChangeStatusAvaliacao(index, ev) {
      const value = ev.target.value;

      if (value === "8") {
        if (
          (this.tableRows[index + 1] &&
            this.tableRows[index + 1].rowType !== this.tableRowType.TEXT) ||
          !this.tableRows[index + 1]
        ) {
          this.tableRows.splice(index + 1, 0, {
            table_id: ++this.latest_id,
            id: this.tableRows[index].id,
            rowType: this.tableRowType.TEXT,
            codStatus: 8,
            hide: false,
            edit: true
          });
        } else if (
          this.tableRows[index + 1] &&
          this.tableRows[index + 1].rowType === this.tableRowType.TEXT
        ) {
          this.tableRows[index + 1].hide = false;
        }
      } else {
        if (
          this.tableRows[index + 1] &&
          this.tableRows[index + 1].rowType === this.tableRowType.TEXT
        ) {
          this.tableRows[index + 1].hide = true;
        }
      }
    }
  }
};
</script>

<style lang="scss">
.control {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  background: #f7f7f7;
  border-radius: 5px 5px 0 0;

  & > div {
    display: flex;
    align-items: center;
    margin-bottom: 8px;

    .show-control-text {
      font-weight: bold;
      position: relative;
      top: 2px;
      display: inline-block;
      cursor: pointer;
      margin-right: 7px;
    }
  }
}

.table {
  tbody {
    .ttrow {
      td {
        height: auto !important;
        padding: 0 !important;

        & > div {
          box-sizing: border-box;
          max-height: 40px;
          padding: 0.5em 0.75em;
          overflow: hidden;
        }

        .validate {
          .evaluate-text {
            cursor: pointer;
          }

          select {
            font-size: 10px;
            border: 1px solid #7d7d7d;
            border-radius: 3px;
          }
        }

        &.td-divisor {
          div {
            background: #ffffff;
            color: #333333;
            font-weight: bold;
            border-bottom: 2px solid #555555;
            text-align: center;
          }
        }

        &.td-text {
          & > div {
            max-height: 300px !important;
            overflow-y: auto;
          }

          textarea {
            width: 100%;
            max-width: 100%;
            min-width: 100%;
            min-height: 50px;
            max-height: 250px;
            font-size: 14px;
            border: 1px solid rgb(125, 125, 125);
            border-radius: 5px;
          }
        }
      }
    }
  }
}
</style>
